import { useRef, useState } from 'react'
import { Spinner } from 'react-bootstrap'
import styles from './StickyTable.module.css'
import { SortSlotContext } from './utils'
import { useMobileCards } from './useMobileCards'

type Props = React.DetailedHTMLProps<
  React.HTMLAttributes<HTMLDivElement>,
  HTMLDivElement
> & {
  onEndReached?: () => void
  isLoading?: boolean
}

export default function SticyTable({
  onEndReached,
  isLoading,
  className,
  children,
  ...props
}: Props) {
  const tableRef = useRef<HTMLTableElement>(null)
  const [sortSlot, setSortSlot] = useState<HTMLDivElement | null>(null)
  const handleCardClick = useMobileCards(tableRef)

  return (
    <div
      onScroll={(e) => {
        const target = e.target as HTMLDivElement
        const bottom =
          target.scrollHeight - target.scrollTop - target.clientHeight <= 1
        if (bottom && onEndReached) {
          onEndReached()
        }
      }}
      {...props}
      className={`position-relative table-responsive sticky-table mobile-cards ${styles.StickyTable} ${
        className ?? ''
      }`}
    >
      <div ref={setSortSlot} className={styles.SortSlot} />
      <table ref={tableRef} className="table table-bottaro" onClick={handleCardClick}>
        <SortSlotContext.Provider value={sortSlot}>
          {children}
        </SortSlotContext.Provider>
      </table>
      {isLoading && (
        <div
          className="d-flex justify-content-center align-items-center position-absolute w-100 h-100"
          style={{
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
          }}
        >
          <Spinner animation="border" role="status" variant="secondary" />
        </div>
      )}
    </div>
  )
}
